import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TeacherRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user || !user.is_teacher) {
        return <Navigate to="/main" />; // Or show an unauthorized page
    }

    return children ? children : <Outlet />;
};

export default TeacherRoute;
